import React, { useEffect } from 'react';
import { useState, useRef } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './availability.css';
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from 'react-router-dom';
import { getDatabase, ref, onValue } from "firebase/database";
import Popup from '../../Components/ADpopUp';
import { format, startOfMonth, endOfMonth } from 'date-fns';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function MyCalender(props) {
  const { t } = useTranslation();
  const [date, setDate] = useState('');
  const [selectedOption, setSelectedOption] = useState('AC Hall');
  const [dropvalue, DropsetValue] = React.useState('');
  const [getmonth, setMonth] = React.useState('');
  const [serverMonth, setServerMonth] = React.useState('');
  const [getOptions, setOptions] = React.useState([]);
  const [disabledDates, setDisableDates] = React.useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [activeMonth, setActiveMonth] = useState(new Date());
  // const [submittedData, setSubmittedData] = useState(null);
  const [price, setPrice] = useState({
    Ac: '',
    Non_Ac: ''
  });
  const navigate = useNavigate();
  const db = getDatabase();
  const isAdmin = props.isAdmin
  let engagementDetails = {};

  const location = useLocation();
  const previousLocation = useRef(location); // Store the previous location

  useEffect(() => {
    // console.log("location----",location);
    const handleBackButtonClick = () => {
      // console.log('Back button clicked');
      // Custom logic here, e.g., navigate somewhere else
      navigate('/', { state: null });
    };

    // if (previousLocation.current !== location) {
    if (location.pathname === "/") {
      handleBackButtonClick();
      // }
    }

    previousLocation.current = location; // Update previous location on every render
  }, []);


  useEffect(() => {
    // console.log(engagementDetails);
    localStorage.removeItem('booking');
    const starCountRef = ref(db, 'available_month');
    onValue(starCountRef, (snapshot) => {
      const data = snapshot.val();
      setMonth(data.Value)
    });

    const query = ref(db, "Functions/" + t('LANG') + "/functionList");
    onValue(query, (snapshot) => {
      const data = snapshot.val();
      const getdata = [];
      if (snapshot.exists()) {
        // Push default option
        getdata.push({ label: '--Select--', value: 'Null' });

        // Iterate over each item in the snapshot and push them into getdata array
        Object.values(data).forEach((res) => {
          getdata.push({ label: res, value: res });
        });

        // Log the formatted data
        setOptions(getdata)

      }
    });

    const starCountRef1 = ref(db, 'bookedDates/');
    onValue(starCountRef1, (snapshot) => {
      const data1 = snapshot.val();
      if (snapshot.exists()) {
        const bDates = Object.values(data1).map(entry => {
          const parts = entry.formatedDate.split('/');
          const formattedDateString = `${parts[2]}-${parts[1]}-${parts[0]}`;
          return {
            date: new Date(formattedDateString),
            status: entry.status
          };
        });
        setDisableDates(bDates)

      }
    });

  }, [t, db])

  useEffect(() => {
    const serverDatetimeRef = ref(db, '.info/serverTimeOffset');

    // Listen for changes in the server time offset
    onValue(serverDatetimeRef, (snapshot) => {
      // Get the server time offset
      const currentDate = new Date();
      const offset = snapshot.val() || 0;
      const serverTime = new Date(currentDate.getTime() + offset);
      setServerMonth(serverTime.getMonth());
    });
  })

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const handleSubmit = (data) => {
    let userData = data;
    engagementDetails = {
      date: date,
      price: price,
      function: dropvalue,
      type: selectedOption,
      AdminData: userData,
    };
    navigate("/Terms", { state: { data: engagementDetails } })
  };

  const tileDisabled = ({ date, view }) => {
    const filteredDates = disabledDates.filter(item => item.status === 'blocked').map(item => item.date);
    // Check if the view is 'month' and date falls on any of the specified dates
    if (view === 'month') {
      return filteredDates.some((bDate) => date.getDate() === bDate?.getDate() && date.getMonth() === bDate?.getMonth() && date.getFullYear() === bDate?.getFullYear());
    }
    return false;
  };

  function handleChange(event) {
    setSelectedOption(event.target.value);
  }

  const handleDropChange = (event) => {
    DropsetValue(event.target.value);
  };

  const bookNow = () => {
    if (date !== '') {
      if (date >= new Date()) {
        if (dropvalue !== 'Null' && dropvalue !== '') {
          engagementDetails = {
            date: date,
            price: price,
            function: dropvalue,
            type: selectedOption
          };
          setIsPopupOpen(true);
        } else {
          alert(t('Select_function'));
        }
      } else {
        alert(t('Please select proper date'));
      }
    } else {
      alert(t('Select_Date'));
    }
  }

  const currentDate = new Date();

  // Get the year of the current date
  let year = currentDate.getFullYear();

  // Get the month of the current date
  let admonth = currentDate.getMonth();
  let month = serverMonth;

  // Increment the month by 1 to get the next month
  month = month + getmonth;

  // If the current month is December (11), reset the month to January (0) and increment the year
  if (month === 12) {
    month = 0; // January
    year++;
  }

  const nextMonthDate = (!isAdmin) ? new Date(year, month, currentDate.getDate()) : new Date(year + 1, admonth, currentDate.getDate());

  const onDateSelected = (date) => {
    setDate("");
    let selectedDate = date.getDate() + "/" + date.getMonth() + "/" + date.getFullYear()
    if (disabledDates.some(disabledDate => date.getDate() === disabledDate.date.getDate() && date.getMonth() === disabledDate.date.getMonth() && date.getFullYear() === disabledDate.date.getFullYear())) {
      setDate("");
      alert(`Selected date ${selectedDate} is Booked.`);
    } else {
      setDate(date);
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      const query = ref(db, "Prices");
      onValue(query, (snapshot) => {
        const data = snapshot.val();
        let monthName = months[date.getMonth()]
        setPrice(data[monthName])
      });
    }
  }

  const commonTileClassName = ({ date, view }) => {
    if (view === 'month') {
      const start = startOfMonth(activeMonth);
      const end = endOfMonth(activeMonth);

      if (date < start || date > end) {
        return 'invisible';
      }
    }
    const filteredDates = disabledDates.filter(item => item.status === 'pending').map(item => item.date);
    const bookedDates = disabledDates.filter(item => item.status === 'approved').map(item => item.date);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (date < today) {
      return 'highlight-rd';
    }

    if (filteredDates.some((bDate) => date.getDate() === bDate?.getDate() && date.getMonth() === bDate?.getMonth() && date.getFullYear() === bDate?.getFullYear())) {
      return 'highlight'
    }
    if (bookedDates.some(bookedDate =>
      format(bookedDate, 'yyyy-MM-dd') === format(date, 'yyyy-MM-dd')
    )) {
      return 'highlight-gr';
    }
    return 'rounded-lg';
  };

  return (
    <section className="availability-section" id="availability">
      {/* Header */}
      <div className="availability-header">
        <h2>{t('Dates_heading')}</h2>
        <p>Green dates indicate booked events. Navigate through months to view all bookings.</p>
      </div>

      {/* Controls: Event Type + AC/Non-AC */}

      <div className="availability-controls">
        <div className="availability-control-group">
          <label>{t('Function_type')}:</label>
          <select value={dropvalue} onChange={handleDropChange}>
            {getOptions.map((option, idx) => (
              <option key={idx} value={option.value}>{option.label}</option>
            ))}
          </select>
        </div>
        {isAdmin && (
          <div className="availability-control-group">
            <label>Select AC / Non-AC:</label>
            <select value={selectedOption} onChange={handleChange}>
              <option value="AC Hall">{t('Ac_hall')} - {t('Rs')} {price?.acTotal}</option>
              <option value="Non AC Hall">{t('Non_ac_hall')} - {t('Rs')} {price?.NonAcTotal}</option>
            </select>
          </div>
        )}
      </div>

      {/* Calendar */}
      <div className="calendar-card">
        {isAdmin ? (
          <Calendar
            onChange={onDateSelected}
            value={date}
            locale={t('LANG')}
            tileDisabled={tileDisabled}
            tileClassName={commonTileClassName}
            onActiveStartDateChange={({ activeStartDate }) => {
              if (activeStartDate) {
                setActiveMonth(activeStartDate);
              }
            }}
          />
        ) : (
          <Calendar
            onChange={onDateSelected}
            value={date}
            minDate={new Date()}
            maxDate={nextMonthDate}
            locale={t('LANG')}
            tileDisabled={tileDisabled}
            tileClassName={commonTileClassName}
            onActiveStartDateChange={({ activeStartDate }) => {
              if (activeStartDate) {
                setActiveMonth(activeStartDate);
              }
            }}
          />
        )}
      </div>

      {/* Book Now Button */}
      {isAdmin && (
        <button className="availability-book-btn" onClick={bookNow}>
          {t('Book_now')}
        </button>
      )}

      {/* Legend */}
      <div className="availability-legend">
        <div className="legend-item">
          <div className="legend-dot unavailable" />
          <span>Unavailable</span>
        </div>
        <div className="legend-item">
          <div className="legend-dot booked" />
          <span>Booked Events</span>
        </div>
        <div className="legend-item">
          <div className="legend-dot pending" />
          <span>Temporarily Unavailable</span>
        </div>
        <div className="legend-item">
          <div className="legend-dot available" />
          <span>Available Dates</span>
        </div>
      </div>

      {/* Contact Details */}
      <div className="availability-contact">
        <p>{t('Contact_details')}</p>
        <p><span className="contact-name">Vivek</span> +91 9448082840</p>
        <p><span className="contact-name">{t('Kantaraju')}</span> +91 9740570582</p>
      </div>

      {/* Popup - keep existing */}
      <div>
        <Popup isOpen={isPopupOpen} onClose={handleClosePopup} onSubmit={handleSubmit} Details={
          engagementDetails = {
            date: date,
            price: price,
            function: dropvalue,
            type: selectedOption
          }
        } />
      </div>
    </section>
  );
}
